import React, { useEffect, useState } from "react";
import { db } from "../../firebase/config";
import {
  collection,
  addDoc,
  onSnapshot,
  deleteDoc,
  doc,
  updateDoc,
} from "firebase/firestore";

import { storage } from "../../firebase/config";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import {

  FormControlLabel,

  Checkbox,
  FormGroup,
  Modal, Button
} from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


import { Loader } from "../../Components/Loader/loader";
import { Cancha } from "../CanchaFutbol/Cancha";
import logo from '../../Imgs/logoKabra.png';
import DownloadIcon from '@mui/icons-material/Download';

const Listado = () => {
   const [loading, setLoading] = useState(false)

  const [posicion, setPosicion] = useState([]);

  const [numero, setNumero] = useState(0);
  const [pago, setPago] = useState(0);
  const [nombre, setNombre] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [items, setItems] = useState([]);
  const [editandoId, setEditandoId] = useState(null);
const [openModal, setOpenModal] = useState(false);
const [openModal1, setOpenModal1] = useState(false);

const [imagen, setImagen] = useState(null);
const [preview, setPreview] = useState(null);
const [imagenActual, setImagenActual] = useState("");

////modal
const handleOpenModal = () => setOpenModal(true);
const handleCloseModal = () => setOpenModal(false);

const handleOpenModal1 = () => setOpenModal1(true);
const handleCloseModal1 = () => setOpenModal1(false);


////modal

  useEffect(() => {
    const unsubscribe = onSnapshot(collection(db, "Plantel"), (snapshot) => {
      const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setItems(data);
    });
    return () => unsubscribe();
  }, []);

const handleSubmit = async (e) => {
  e.preventDefault();
  if (!nombre) return;

  setLoading(true);

  let imageUrl = "";

  // 🔥 subir imagen si existe
  if (imagen) {
    const safeName = imagen.name.replace(/[^\w.-]/g, "_");
const imageRef = ref(storage, `jugadores/${Date.now()}_${safeName}`);
    await uploadBytes(imageRef, imagen);
    imageUrl = await getDownloadURL(imageRef);
  }

  const numeroNormalizado = numero.trim().toUpperCase();

  const existeNumero = items.find(
    (item) => item.numero === numeroNormalizado && item.id !== editandoId
  );

  if (existeNumero) {
    alert("Ya existe un jugador con ese número.");
    setLoading(false);
    return;
  }

const jugadorData = {
  numero: numeroNormalizado,
  posicion,
  nombre,
  pago,
  descripcion,
  imagen: imageUrl || imagenActual, // 🔥 ACÁ VA
  fecha: new Date(),
};

  if (editandoId) {
    const itemRef = doc(db, "Plantel", editandoId);
    await updateDoc(itemRef, jugadorData);
    setEditandoId(null);
  } else {
    await addDoc(collection(db, "Plantel"), jugadorData);
  }

  // limpiar
  setNumero("");
  setPosicion("");
  setNombre("");
  setPago("");
  setDescripcion("");
  setImagen(null);
  setPreview(null);

  setLoading(false);
};


  const handleDelete = async (id) => {
    const itemRef = doc(db, "Plantel", id);
    await deleteDoc(itemRef);
  };

const handleEdit = (item) => {
  handleCloseModal();

  setNumero(item.numero);
  setPosicion(item.posicion);
  setNombre(item.nombre);
  setDescripcion(item.descripcion);
  setPago(item.pago);

  setImagenActual(item.imagen || ""); // 👈 guardar imagen previa

  setEditandoId(item.id);
};


const handleCheckboxChange = (value, estado, setEstado) => {
  if (estado.includes(value)) {
    setEstado(estado.filter((item) => item !== value));
  } else {
    setEstado([...estado, value]);
  }
};


  const exportToExcel = () => {
  const worksheetData = items.map((item) => ({
    POSICION: item.posicion,
    NUMERO: item.numero,
    JUGADOR: item.nombre,
    PAGO: item.pago,
    ANOTACIONES: item.descripcion,
    /*...nombres.reduce((acc, nombre) => {
      acc[nombre.toUpperCase()] = item[nombre] || "";
      return acc;
    }, {}),*/
  }));

  const worksheet = XLSX.utils.json_to_sheet(worksheetData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Plantel");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const data = new Blob([excelBuffer], {
    type: "application/octet-stream",
  });

  saveAs(data, "Plantel.xlsx");
};

const avatarUrl= 'https://firebasestorage.googleapis.com/v0/b/franco-dev-c9c39.firebasestorage.app/o/jugadores%2F1776642790289_avatar.png?alt=media&token=1334f3f4-eda5-4bea-a5f8-0f433a72a788'
const totalPago = items.reduce((acc, item) => acc + Number(item.pago || 0), 0);


const jugadoresParaCancha = items.map((item) => ({
  id: item.id,
  nombre: item.nombre,
  numero: Number(item.numero),
  posicion: Array.isArray(item.posicion) ? item.posicion : [],
}));



  return (
    <>
    
                     <div className="formulario-plantel">
       
        <form onSubmit={handleSubmit} className="formulario-plantel__form" >
           <h2 style={{ padding: 20, color: 'white', fontWeight: 600 }}>{editandoId ? "Editar Dato" : "Cargar Jugador"}</h2>

         <div className="formulario-plantel__nombreYlogo"> 
              
                     <div className="formulario-plantel__logo"> 
                                  <img
                            className="formulario-plantel__logoimg"
                            src={logo}
                            alt="logo"
                           />
                          </div>
                            <br />
               <p style={{ margin: 0, fontWeight: 500, color: 'white'}}>Nombre Jugador</p>
          <input
            style={{ textTransform: "uppercase" }}
            value={nombre}
            onChange={(e) => setNombre(e.target.value.toUpperCase())}
            placeholder="Nombre"
            required
          />
      
      
            </div>
                          <p style={{ margin: 0, fontWeight: 500, color: 'white'}}>Foto</p>

                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        setImagen(file);

                        if (file) {
                          setPreview(URL.createObjectURL(file));
                        }
                      }}
                    />

                    {preview && (
                      <img
                        src={preview}
                        alt="preview"
                        style={{ width: 100, marginTop: 10, borderRadius: 10 }}
                      />
                    )}
            <br />
          <p style={{ margin: 0, fontWeight: 500 , color: 'white'}}>Puesto</p>

            <FormGroup row>
              {["ARQ","LI","LD","DF","VI","VD","MC","DC"].map((pos) => (
                <FormControlLabel
                  key={pos}
                  control={
                    <Checkbox
                      checked={Array.isArray(posicion) && posicion.includes(pos)}
                      onChange={() =>
                        handleCheckboxChange(pos, posicion || [], setPosicion)
                      }
                    />
                  }
                  label={pos}
                  sx={{ color: "white"  }}
                />
              ))}
            </FormGroup>
          <br />
          <p style={{ margin: 0, fontWeight: 500 , color: 'white'}}>Numero</p>
          <input
            style={{ textTransform: "uppercase" }}
            value={numero}
            type="number"
            onChange={(e) => setNumero(e.target.value.toUpperCase())}
            placeholder="Número"
            required
          />
          <br />
            
          <p style={{ margin: 0, fontWeight: 500 , color: 'white'}}>Pago Total</p>
          <input
            style={{ textTransform: "uppercase" }}
            value={pago}
            type="number"
            onChange={(e) => setPago(e.target.value.toUpperCase())}
            placeholder="Pago Total"
  
          />
           <br />
          <p style={{ margin: 0, fontWeight: 500, color: 'white'}}>Anotaciones</p>
          <textarea
            style={{ textTransform: "uppercase" }}
            value={descripcion}
            onChange={(e) => setDescripcion(e.target.value.toUpperCase())}
            placeholder="Comentarios"
          />
          <br />
          <button type="submit" className={editandoId ? 'btn btn-info' : 'btn btn-success'}>{editandoId ? "Actualizar" : "Guardar"}</button>
      
            <div style={{ color: 'white', marginTop: '1rem', fontWeight: 'bold', textAlign:'center' }}>
              TOTAL PAGO: ${totalPago}
            </div>
         
             
          
        </form>
          <br/>
          <div style={{color:'white', textAlign:'center'}}>_____________________________________</div>
          <div className="btn-funciones__ver">
              <button onClick={exportToExcel} className="btn boton-excel">
                      <DownloadIcon style={{ marginRight: 6 }} />
                      Excel
                    </button>
                      <Button variant="contained"  color="secondary" onClick={handleOpenModal} className="boton-excel" style={{ margin: 10 }}>
                Ver Listado
              </Button>
                <Button variant="contained"  color="secondary" onClick={handleOpenModal1} className="boton-excel" style={{ margin: 10 }}>
                Ver Pizarra
              </Button>
        </div>
    <Modal open={openModal} onClose={handleCloseModal}>

 <div className="box-modal">
  <h3 style={{ fontWeight: 600 }}>Listado:</h3>

  <ul className="item-listado" style={{ listStyle: "none", padding: 0 }}>
    {items
      ?.slice()
      ?.sort((a, b) => (a.nombre || "").localeCompare(b.nombre || ""))
      ?.map((item, index) => (
          <li key={item.id} className="jugador-card">

            <div className="jugador-card__header">
              <div className="jugador-numero">{item.numero}</div>
              <div className="jugador-nombre">{item.nombre}</div>
            </div>
                <div className="jugador-box__info">
                  <div className="jugador-info">
                    {item.posicion?.length > 0 && (
                      <span className="badge-posicion">{item.posicion.join(" / ")}</span>
                    )}

                    {item.pago > 0 && (
                      <span className="badge-pago">${item.pago}</span>
                    )}
                  </div>
                  <div className="jugador-info--img">
                        {item.imagen && (
                        <img
                                    src={item.imagen || avatarUrl}
                                    alt={item.nombre}
                                    className="jugador-img"
                                    onError={(e) => {
                                      e.target.src = avatarUrl;
                                    }}/>
                      )}
                  </div>
                </div>    
            {item.descripcion && (
              <div className="jugador-descripcion">{item.descripcion}</div>
            )}

            <div className="jugador-acciones">
              <button onClick={() => handleEdit(item)}>
                <EditIcon />
              </button>

              <button onClick={() => handleDelete(item.id)}>
                <DeleteIcon />
              </button>
            </div>
        
          </li>
      ))}
  </ul>

  <Button onClick={handleCloseModal} variant="outlined" style={{ marginTop: 10 }}>
    Cerrar
  </Button>
</div>
 {/* </Box>*/}
</Modal>
    


  
    <Modal open={openModal1} onClose={handleCloseModal1}>

  <div className="box-modal">

      <Cancha jugadores={jugadoresParaCancha}/>
    
  <Button onClick={handleCloseModal1} variant="outlined" style={{ marginTop: 10 }}>
    Cerrar
  </Button>
</div>
 {/* </Box>*/}
</Modal>
      </div>

      <hr/>
  
       
      
    </>
  );
};

export default Listado;
